import { moduleFactory } from "@/factories/module";
import { buildAppWindowUrl } from "@/modules/window/build-url";
import { compactWindowUrlForLogging } from "@/modules/window/compact-url-for-logging";
import { _getCurrentWindowUrlSearchParams } from "@/modules/window/url-params";
import {
  getWindowGoogleIdentityOAuthRedirectUrl,
  getWindowGoogleCalendarOAuthRedirectUrl,
} from "@/modules/window/google-redirect";
import { getWindowOutlookCalendarOAuthRedirectUrl } from "@/modules/window/outlook-redirect";
import { getWindowSlackOAuthRedirectUrl } from "@/modules/window/slack-redirect";
import { forceHardReloadWindow, forceReloadWindow } from "@/modules/window/reload";
import {
  navigateToExternalWindowUrlAndPreserveHistory,
  navigateToExternalWindowUrl,
  navigateToInternalWindowUrl,
  navigateToWindowUrlAndRefresh,
  openWindowUrlInNewTab,
} from "@/modules/window/navigation";
import { getWindowOrigin } from "@/modules/window/origin";
import { getWindowLocationHostname } from "@/modules/window/location";

export const windowModule = moduleFactory.create({
  compactUrlForLogging: compactWindowUrlForLogging,
  currentUrlSearchParams: _getCurrentWindowUrlSearchParams,
  buildUrl: buildAppWindowUrl,
  getOrigin: getWindowOrigin,
  getLocationHostname: getWindowLocationHostname,
  forceReload: forceReloadWindow,
  forceHardReload: forceHardReloadWindow,
  navigateToInternal: navigateToInternalWindowUrl,
  navigateToExternal: navigateToExternalWindowUrl,
  navigateToExternalAndPreserveHistory: navigateToExternalWindowUrlAndPreserveHistory,
  navigateToAndRefresh: navigateToWindowUrlAndRefresh,
  openInNewTab: openWindowUrlInNewTab,
  getGoogleIdentityOAuthRedirectUrl: getWindowGoogleIdentityOAuthRedirectUrl,
  getGoogleCalendarOAuthRedirectUrl: getWindowGoogleCalendarOAuthRedirectUrl,
  getOutlookCalendarOAuthRedirectUrl: getWindowOutlookCalendarOAuthRedirectUrl,
  getSlackOAuthRedirectUrl: getWindowSlackOAuthRedirectUrl,
});
